import { default as React, FC } from "react";
import { useSelector } from "react-redux";
import { useOpenUrlCallback } from "../../hooks/useOpenUrlCallback";
import { executeAction } from "../../store/actions";
import { ChatState, VisualState } from "../../store/ChatState";
import { useChatServerDispatch } from "../../utils/useChatServerDispatch";
import {
    ChatServerActionLink,
    getChatServerActionLinkLabel,
    isChatServerActionLink,
} from "../../xapp/ChatServerMessage";
import ChatChips from "./ChatChips";
import { useChatDispatch } from "../../utils/useChatDispatch";

export interface Props {}

const ChatChipsContainer: FC<Props> = (_) => {
    const dispatch = useChatServerDispatch();
    const chips = useSelector<ChatState, (string | ChatServerActionLink)[]>((state) => state.chips);
    const chatDispatch = useChatDispatch();
    const visuals = useSelector<ChatState, VisualState>((state) => state.visuals);

    const openUrl = useOpenUrlCallback();

    function optionOnChange(option: string | ChatServerActionLink) {
        const actionUrl = isChatServerActionLink(option) && option.actionUrl;

        if (actionUrl) {
            openUrl(actionUrl, chatDispatch, visuals);
        } else {
            // add metadata
            dispatch(
                executeAction(getChatServerActionLinkLabel(option), {
                    action: "click",
                    ui: "chip",
                })
            );
        }
    }
    return (
        <div
            className={`message-list-container__chips ${
                !chips?.length ? "message-list-container__chips--empty" : ""
            }`}>
            <ChatChips options={chips} onOptionClick={optionOnChange} />
        </div>
    );
};

export default ChatChipsContainer;
